import { createHelpers } from 'vuex-map-fields'
import * as mutationTypes from './mutationTypes'

const { updateMemberManagementField } = createHelpers({
  mutationType: 'updateMemberManagementField'
})

export default {
  updateMemberManagementField,

  [mutationTypes.SET_MEMBER_DETAILS] (state, memberDetails) {
    if (memberDetails.benefits === null) {
      memberDetails.benefits = {
        benefitDisplayCategories: [],
      }
    }

    if (memberDetails.amountLimit === null) {
      memberDetails.amountLimit = {
        decliningBalance: {
          benefitCategoryLimits: []
        },
        deductibleBalance: {}
      }
    }
    state.memberDetails = memberDetails
    state.memberDetailsLoading = false
  },

  [mutationTypes.BEGIN_LOADING_MEMBER_DETAILS](state) {
    state.memberDetailsLoading = true
  },

  [mutationTypes.SET_MEMBER_DETAILS_LOADING](state, memberDetailsLoading) {
    state.memberDetailsLoading = memberDetailsLoading
  },

  [mutationTypes.SET_MEMBER_ADDRESSES] (state, memberAddresses) {
    state.memberAddresses = memberAddresses.addresses
    state.memberAddressesLoading = false
  },

  [mutationTypes.BEGIN_LOADING_MEMBER_ADDRESSES] (state) {
    state.memberAddressesLoading = true
  },

  [mutationTypes.SET_MEMBER_TRANSACTIONS] (state, memberTransactions) {
    state.memberTransactions = memberTransactions
    state.memberTransactionsLoading = false
  },

  [mutationTypes.SET_MEMBER_TRANSACTIONS_ERROR] (state, errorResponse) {
    state.memberTransactionsErrorMessage = errorResponse.userMessage
    state.memberTransactions = []
    state.memberTransactionsLoading = false
  },

  [mutationTypes.BEGIN_LOADING_MEMBER_TRANSACTIONS] (state) {
    state.memberTransactionsLoading = true
  },

  [mutationTypes.SET_MEMBER_TRANSACTION_DRAFTS] (state, memberTransactionDrafts) {
    state.memberTransactionDrafts = memberTransactionDrafts
    state.memberTransactionsLoading = false
  },

  [mutationTypes.SET_UPDATING_MEMBER] (state, memberUpdating) {
    state.memberUpdating = memberUpdating
  },

  [mutationTypes.SET_MEMBER_TRANSACTION_DETAILS_LOADING] (state, memberTransactionDetailsLoading) {
    state.memberTransactionDetailsLoading = memberTransactionDetailsLoading
  },

  [mutationTypes.SET_ACTIVE_BENEFIT_CATEGORY_INDEX] (state, index) {
    state.activeBenefitCategoryIndex = index
  },
  SET_TRANSACTION_SEARCH (state, transactionSearch) {
    state.transactionSearch = transactionSearch;
  }
}
